export default {
  suppliers: [],
};
